










































import { Vue, Component, Prop } from "vue-property-decorator";

import DividendsHistory from "./DividendsHistory.vue";

import { portfolioStore } from "@/portfolio/store";
import { Dividends, Portfolio } from "./types";

@Component({
  components: {
    DividendsHistory
  }
})
export default class DividendsTab extends Vue {
  reinvest() {}

  withdraw() {}

  defaultDividends: Dividends = {
    nextDistribution: 0,
    totalEarned: 0,
    availableFunds: 0
  };
  async mounted() {
    if (portfolioStore.state.items.length === 0) {
      await portfolioStore.loadPortfolio();
    }
    this.defaultDividends = portfolioStore.state.items[0].dividends;
  }
}
